import { Control, Controller } from "react-hook-form";
import React, { useEffect, useState } from "react";

import { ControlledTextFieldFilled } from "./ControlledTextField";
import { Autocomplete, Chip, createFilterOptions, TextField } from "@mui/material";

// import HelperInputText from "./HelperInputText";
// import { removeDuplicatesById } from "../../utils";
import { EntityWithIdAndDescription, EntityWithIdAndDescriptionFields, EntityWithIdFields } from "src/types/baseEntities";

interface FilterEntity extends EntityWithIdAndDescription {
    title: string
}
const filter = createFilterOptions<FilterEntity>();

interface ControlledAutocompleteProps /*extends AutocompleteProps<any, boolean, boolean, boolean>*/ {
    loadOptions: () => Promise<any[]> | undefined,
    control: Control<any>,
    name: string,
    label?: string | null,
    defaultValues?: any[];
    disabled?: boolean,
    multiple?: boolean,
    valueField?: string,
    optionField?: string
    onAddOption?: (value: string, prevValues: any[]) => void,
    required?: boolean,
    readOnly?: boolean

    disableClearable?: boolean,
}

export const ControlledAutocomplete = (props: ControlledAutocompleteProps) => {
   
    //const theme = useTheme();
    
    //const classes = controlledTextFieldStyles(theme);

    const [loading, setLoading] = useState(false);
    const [options, setOptions] = useState<any[]>([])

    const { loadOptions } = props;

    useEffect(() => {
        const request = loadOptions();

        if (request) {
            setLoading(true);

            request.then(options => {
                setOptions(options);
                setLoading(false);
            }).catch(() => setLoading(false))
        }
        else
            setOptions([]);
    }, [loadOptions])

    return (
        <Controller
            control={props.control}
            name={props.name || ''}
            render={({ field: { onChange, value, ...field }, fieldState: { error } }) => {
                if (props.disabled)
                    return (
                        <ControlledTextFieldFilled
                            {...props}
                            select
                            options={options}
                        />
                    );
                if (loading)
                    return (
                        <ControlledTextFieldFilled
                            {...props}
                            select
                            options={undefined}
                        />
                    );

                return (
                    <Autocomplete
                        {...field}
                        options={options}
                        defaultValue={props.defaultValues}
                        onChange={(_, data) => {
                            if (data)
                                if (props.multiple) {
                                    if (!!props.onAddOption) {
                                        const newValue = data.filter((x: any) => !x.id);
                                        if (newValue && newValue.length)
                                            props.onAddOption && props.onAddOption(newValue[0][EntityWithIdAndDescriptionFields.Description], data);
                                    }

                                    // onChange(removeDuplicatesById(data))
                                } else
                                    if (!data.id)
                                        props.onAddOption && props.onAddOption(data[EntityWithIdAndDescriptionFields.Description], data);
                                    else
                                        onChange(props.valueField ? props.multiple ? data.map((d: any) => d?.[props.valueField!]) : data?.[props.valueField] : data)
                            else {
                                onChange(undefined);
                            }
                        }}

                        // onInputChange={(_, data) => {

                        // }}
                        filterOptions={(options, params) => {
                            const filtered = filter(options, params);

                            const { inputValue } = params;

                            // Suggest the creation of a new value
                            const isExisting = options.some((option) => inputValue === option.description);
                            if (inputValue !== '' && !isExisting && !!props.onAddOption) {
                                const input = {
                                    [EntityWithIdFields.Id]: 0,
                                    [EntityWithIdAndDescriptionFields.Description]: inputValue
                                }
                                filtered.push({
                                    ...input,
                                    title: `Adicione "${inputValue}"`,
                                });
                            }

                            return filtered ?? [];
                        }}
                        multiple={props.multiple}
                        disabled={props.readOnly}
                        disableClearable={props.disableClearable}
                        ChipProps={{ color: 'primary' }}
                        id={`id_${props.name}`}
                        key={`autocomplete_id_${props.name}`}
                        style={{ width: '100%' }}
                        getOptionLabel={(option) => props.optionField ? option[props.optionField] : (option.title ? option.title : option.descripcion)}

                        // getOptionSelected={((option: any, value: any) => value.hasOwnProperty('id') ? (option.id === value?.id) : (option.id === value))}
                        isOptionEqualToValue={(option: any, value: any) => value.hasOwnProperty('id') ? (option.id === value?.id) : (option.id === value)}
                        renderTags={(value: any[], getTagProps) =>
                            value.map((option: any, index: number) => (
                                // eslint-disable-next-line react/jsx-key
                                <Chip
                                    color="primary"
                                    label={props.optionField ? option[props.optionField] : option.descripcion}
                                    sx={{
                                        '& > svg': {
                                            fontSize: '1.4rem !important'
                                        }
                                    }}
                                    {...getTagProps({ index })}
                                />
                            ))
                        }
                        renderInput={(params) => {
                            if (props.multiple) {
                                return (
                                    
                                        <TextField {...params}
                                            margin="normal"
                                            variant="outlined"
                                            size="small"
                                            error={!!error} 
                                            label={props.label}
                                            required={props.required}

                                            // className={classes.textFilled}
                                            inputProps={{
                                                ...params.inputProps
                                            }}
                                            focused={!!params.inputProps.value}
                                        />
                                    
                                );
                            }

                            const optionSelect = options.find(x => x.id === value);

                            return (
                                    <TextField {...params}
                                        margin="normal"
                                        variant="outlined"
                                        size="small"
                                        error={!!error}
                                        label={props.label} 
                                        required={props.required}

                                        inputProps={{
                                            ...params.inputProps,
                                            value: (value && optionSelect) ? // @ts-ignore
                                                props.optionField ? optionSelect[props.optionField] : optionSelect.descripcion : params.inputProps.value
                                        }}

                                        // @ts-ignore
                                        focused={!!params.inputProps.value}
                                    />

                            )
                        }}
                    />
                )
            }}
        />
    )
}